/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISzfMapData } from './szf-map.data';
import { ISzfMapProps } from './szf-map.props.autogenerated';

export interface ISzfMapViewProps extends ISzfMapProps<ISzfMapData> {}

/**
 *
 * SzfMap component
 * @extends {React.PureComponent<ISzfMapProps<ISzfMapData>>}
 */
class SzfMap extends React.PureComponent<ISzfMapProps<ISzfMapData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default SzfMap;
